import React from 'react';
import { Autocomplete, TextField, Chip, Box } from '@mui/material';

const ChipSelectInput = ({
  label,
  values = [],
  onChange,
  options = [],
  error,
  helperText,
}) => {
  return (
    <Box className="chip-select-input">
      <Autocomplete
  multiple
  options={options}
  value={values}
  onChange={(event, newValue) => onChange(newValue)}
  getOptionLabel={(option) => option} 
  renderTags={(value, getTagProps) =>
    value.map((option, index) => (
      <Chip
        variant="outlined"
        label={option}
        {...getTagProps({ index })}
        key={index}
      />
    ))
  }
  renderInput={(params) => (
    <TextField
      {...params}
      label={label}
      error={error}
      helperText={helperText}
    />
  )}
/>

    </Box>
  );
};

export default ChipSelectInput;
